module.exports = __webpack_public_path__ + "static/media/d23kz.489ff712.pdf";